import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Schedule from "@/components/site/Schedule";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import Tools from "@/components/site/Tools";
import ShipmentJourney from "@/components/site/ShipmentJourney";
import WhyChooseUs from "@/components/site/WhyChooseUs";
import Coverage from "@/components/site/Coverage";
import Comparison from "@/components/site/Comparison";
import Reviews from "@/components/site/Reviews";
import FAQ from "@/components/site/FAQ";
import Prohibited from "@/components/site/Prohibited";
import CTA from "@/components/site/CTA";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import FloatingWhatsApp from "@/components/site/FloatingWhatsApp";
import { LOGO_URL } from "@/lib/site-data";

function App() {
  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;

    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id.length > 1) {
        const el = document.querySelector(id);
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -92 });
        }
      }
    };
    document.addEventListener("click", onClick);

    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <div aria-hidden className="pointer-events-none fixed inset-0 z-[1] flex items-center justify-center overflow-hidden">
        <img
          src={LOGO_URL}
          alt=""
          className="w-[78vw] max-w-[1000px] opacity-[0.045]"
          style={{ mixBlendMode: "multiply" }}
        />
      </div>
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Schedule />
        <About />
        <Services />
        <Tools />
        <ShipmentJourney />
        <WhyChooseUs />
        <Coverage />
        <Comparison />
        <Reviews />
        <FAQ />
        <Prohibited />
        <CTA />
        <Contact />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
